// extracted by mini-css-extract-plugin
export default {"heading":"NewLoanApplication_heading__Snso5","wrapper":"NewLoanApplication_wrapper__YvtL3"};